var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 12.6667H11.9987V5.33333H6.66536V12.6667ZM5.33203 5.328C5.33203 4.59467 5.93336 4 6.67136 4H11.9927C12.7327 4 13.332 4.59533 13.332 5.328V12.672C13.332 13.4053 12.7307 14 11.9927 14H6.67203C6.49685 14.0008 6.32322 13.9671 6.16107 13.9008C5.99892 13.8344 5.85142 13.7368 5.72699 13.6135C5.60256 13.4902 5.50364 13.3436 5.43587 13.182C5.3681 13.0205 5.33282 12.8472 5.33203 12.672V5.328Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10.6667V3.328C3.33203 2.59467 3.93336 2 4.67136 2H9.9987V10.6667H3.33203ZM4.66536 10.6667H9.9987V3.33333H4.66536V10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.1d7dd0fba2aaf4af83032e1b9bead0be.svg";
export { ForwardRef as ReactComponent };